import React, { ReactNode } from "react";
import "sass/components/Body.scss";

type BodyProps = {
  children: ReactNode;
  indexScroll: ReactNode;
};

function Body({ children, indexScroll }: BodyProps) {
  return (
    <div className="body-container">
      <div className="body-content">{children}</div>
      {indexScroll}
    </div>
  );
}

export default Body;
